import React from "react";
import { Box, Card, CardContent, Typography } from "@material-ui/core";
import httpClient from "../../lib/httpClient";
import { useEffect, useState } from "react";
import { FormControl, MenuItem, Select, CircularProgress, FormHelperText } from "@material-ui/core";

import { formatDateValue } from "../util/tableUtils";

import { getBlobUrlFromS3, fetchImageUrl, getJsonFromS3 } from "../../lib/privateS3Access";

export const NdviByParcel = (props) => {
  const { policyNumber, complainId } = props;
  const [parcelsV3, setParcelsV3] = useState([]);
  const defaultParcel = "1";
  const [parcel, setParcel] = useState(defaultParcel);

  const [jsonIndex, setJsonIndex] = useState({});
  const [render, setRender] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [requestStatus, setRequestStatus] = useState("");

  useEffect(() => {
    if (policyNumber) {
      httpClient()
        .get(`/agriculturePolicies/${policyNumber}/parcelsV3`)
        .then((res) => res.data)
        .then(async (data) => {
          setParcelsV3(data);
          setParcel(data[0].cadastralRecord);
        });
    }
  }, [policyNumber]);

  useEffect(() => {
    const awaitAddJsonIndex = async () => {
      const base = `pageview-agriculture-claims/contratto/${policyNumber}/${complainId}/${parcel}/v4/`;
      const key = `${base}index.json`;
      const bucket = "cys-realerisk-ndvi";
      const indexJsonLocal = await getJsonFromS3(bucket, key);
      // It is {}  if file is missing.

      for (let i = 0; i < indexJsonLocal?.dates?.length; i++) {
        indexJsonLocal.dates[i].signedImages = [];
        for (let j = 0; j < indexJsonLocal.dates[i].images.length; j++) {
          const image = indexJsonLocal.dates[i].images[j];
          const signedUrlImage = await fetchImageUrl(bucket, base + image);

          indexJsonLocal.dates[i].signedImages.push(signedUrlImage);
        }
      }

      indexJsonLocal.signedPlots = [];
      for (let i = 0; i < indexJsonLocal?.plots?.length; i++) {
        const signedUrlImage = await fetchImageUrl(bucket, base + indexJsonLocal.plots[i]);
        indexJsonLocal.signedPlots.push(signedUrlImage);
      }

      if (indexJsonLocal?.dates) {
        const signedScaleImage = await fetchImageUrl(bucket, "scale05.png");
        indexJsonLocal.signedScaleImage = signedScaleImage;

        const imagebefore = indexJsonLocal.dates.find((date) => date.is_selected && date.column === "before")
          .images[0];
        const imageafter = indexJsonLocal.dates.find((date) => date.is_selected && date.column === "after")
          .images[0];

        indexJsonLocal.blobUrlBefore = await getBlobUrlFromS3(bucket, base + imagebefore);
        indexJsonLocal.blobUrlAfter = await getBlobUrlFromS3(bucket, base + imageafter);
        // These remain for the future use. The images are not displayed.
      }

      setJsonIndex(indexJsonLocal);
    };
    awaitAddJsonIndex();
  }, [parcel, render, complainId, policyNumber]);

  // Selection box tpo choose one parcel from the list, the field cadastralRecord contains the parcel id

  const handleChange = (event) => {
    if (event.target.value !== parcel) {
      setParcel(event.target.value);
    }
  };

  const formControl = parcelsV3.length ? (
    // The selector to choose the parcel
    <FormControl variant="outlined">
      <Select labelId="parcel-select-label" id="parcel-select" value={parcel} onChange={handleChange}>
        {parcelsV3.map((parcel, index) => (
          <MenuItem value={parcel.cadastralRecord} key={index}>
            {"NDVI Details for Partita " + parcel.cadastralRecord + " of " + parcelsV3.length}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>Please select a partita</FormHelperText>
    </FormControl>
  ) : (
    <> </>
  );

  const buttonToRequestComputations = (parcel, details) => {
    // Button to request the computations

    let payload = {
      policyNumber: policyNumber,
      claim: complainId,
      cadastralRecord: [`${parcel}`],
      no_cache: true,
      details: details,
    };

    const handleButtonClick = () => {
      setIsLoading(true);
      setRequestStatus("Running computations...");
      httpClient()
        .post(`/proxy/ndvi_reale`, payload)
        .then((res) => res.data)
        .then((data) => {
          setRender((prev) => !prev);
          console.log(data);
          setRequestStatus(
            "Result: " +
              (data?.info ? JSON.stringify(data?.info) : "") +
              " " +
              (data?.warning ? JSON.stringify(data?.warning) : "") +
              " " +
              (data?.error ? JSON.stringify(data?.error) : ""),
          );
          // Currently the response contains either info or warning or error. This might change in the future.
          // It also contains the timing of the computations, but we do not display it.
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx

            setRequestStatus(
              "Error(1): " + error.response.status + ", " + JSON.stringify(error.response.data),
            );
          } else if (error.request) {
            // The request was made but no response was received
            console.error(error.request);
            setRequestStatus("Error(2): No response from server.");
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error("Error", error.message);
            setRequestStatus("Error(3): " + error.message);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    return (
      <button onClick={handleButtonClick}>
        {isLoading ? (
          <Box mr={1}>
            <CircularProgress size={12}></CircularProgress>
          </Box>
        ) : details ? (
          "Request Historical/Geolocation analysis (60 seconds)"
        ) : (
          "Request Computations (15 seconds)"
        )}
      </button>
    );
  };

  const tableOfParcelData = (parcel) => {
    // Table with 5 rows and 6 columns containig PNG images, dates and NDVI values

    if (!jsonIndex?.dates) {
      return <>No results are available on the server. Press buttons above</>;
    }

    return (
      <>
        <img src={jsonIndex.signedScaleImage} alt="NDVI" width="900" />
        <table className="tableWithBorders" style={{ border: "1px solid black", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>NDVI</th>
              <th>Date</th>
              <th>Natural</th>
              <th>
                NDVI
                <br />
                [N]
              </th>
              <th>
                P20 - P80
                <br />
                [N]
              </th>
              <th>
                absDelta
                <br />
                [N]
              </th>
              <th>
                relDelta
                <br />
                [N/N]
              </th>
              <th>
                speed
                <br />
                [N/day]
              </th>

              <th>
                cloud
                <br />
                []
              </th>
            </tr>
          </thead>
          <tbody>
            {jsonIndex.dates.map((date, index) => (
              <tr key={index}>
                <td>
                  <img src={date.signedImages[0]} alt="NDVI" width="200" />
                </td>
                <td>{formatDateValue(date.day)}</td>

                <td>
                  <img src={date.signedImages[1]} alt="NDVI" width="200" />
                </td>

                <td>{date.mean}</td>
                <td>
                  {date.P20}-{date.P80}
                </td>

                <td>{date?.absDelta}</td>
                <td>{date?.relDelta}</td>
                <td>{date?.speed}</td>
                <td>{date?.local_cloud}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {jsonIndex.signedPlots.map((plot, index) => (
          <img key={index} src={plot} alt="NDVI" width="100%" />
        ))}
      </>
    );
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">
          NDVI per Partita: Contratto {policyNumber}, Denuncio {complainId}. Numero partite={parcelsV3.length}
        </Typography>
        <Box p={1}>{formControl}</Box>
        <Box p={1}>{buttonToRequestComputations(parcel, false)}</Box>
        <Box p={1}>{buttonToRequestComputations(parcel, true)}</Box>
        <Box p={1}>{requestStatus}</Box>
        <Box p={1}>{tableOfParcelData(parcel)}</Box>
      </CardContent>
    </Card>
  );
};
